module.exports = __webpack_public_path__ + "45f3e7022c6ff525ea4ab94c0084d03e.png";